//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from '~/eventBus'

export default {
    name: 'IntroHeader',

    data(){ return {
        showSideMenu: 1,
        menu: [
            {
                name: 'Blog',
                color: 'bg-teal-7',
                description: 'Content from here and there. Posts of different stuff and categories. '
            },

            {
                name: 'Projects',
                color: 'bg-purple-7',
                description: 'Find out about my projects and softwares'
            },

            {
                name: 'YouTube Manager',
                color: 'bg-red-7',
                description: 'Multimedia Platform based on YouTube. Stream, View, Select, Set, Catch and consume your favorite YouTube Videos like on netflix and co.'
            },

            {
                name: 'KanaX',
                color: 'bg-pink-7',
                description: 'A new source of streaming. A mix between Netflix, YouTube, Spotify and Deezer.',
            },

            {
                name: 'API Enterprise Router',
                color: 'bg-light-blue-8',
                description: 'Extend, Control, Monitore and Analyse your accessebility to third party SDK with less hassle.'
            },
        ],

        colors: [
            'rose3_1', 'rose3', 'rose', 'blue', 'blue2', 'turkis', 'purple', 'purple2', 'maroon',
        ]
    }},

    computed: {
        randomSelect(){ return this.$util.randomInt(0, this.colors.length - 1) },
        isMobile(){ return this.$q.screen.lt.md }
    },

    methods: {
        goTo(){
            EventBus.$emit('intro.next.clicked')
        }
    }
}
